import { createSelector } from 'reselect'

const selectLedger = state => state.ledger

export const selectSelectedCurrency = createSelector([selectLedger], ledger => ledger.selectedCurrency)

export const selectSectionsData = createSelector([selectLedger], ledger => ledger.sectionsData)

export const selectSuccessMsg = createSelector([selectLedger], ledger => ledger.successMsg)

export const selectSuccess = createSelector([selectLedger], ledger => ledger.success)

export const selectStatus = createSelector([selectLedger], ledger => ledger.status)

export const selectError = createSelector([selectLedger], ledger => ledger.error)

export const selectLedgerLoading = createSelector([selectLedger], ledger => ledger.loading)

export const selectLedgerLoader = createSelector([selectLedger], ledger => ledger.loader)

export const selectFavouriteDashboardId = createSelector([selectLedger], ledger => ledger.favouriteDashboardId)

export const selectSuccessFeeData = createSelector([selectLedger], ledger => ledger.successFeeData)

export const selectSuccessMergedFeeData = createSelector([selectLedger], ledger => ledger.successMergedFeeData)

export const selectSuccessData = createSelector([selectLedger], ledger => ledger.successData)

export const selectCountriesList = createSelector([selectLedger], ledger => ledger.countriesList)

export const selectModalAsset = createSelector([selectLedger], ledger => ledger.modalAsset)

export const selectModalBankAccount = createSelector([selectLedger], ledger => ledger.modalBankAccount)

export const selectOpenBankAccounts = createSelector([selectLedger], ledger => ledger.bankAccountsOpen)

export const selectSupportedBankAccountCurrencies = createSelector([selectLedger], ledger => ledger.supportedBankAccountCurrencies)

export const selectBankBic = createSelector([selectLedger], ledger => ledger.bankBic)

export const selectTransliteratedReference = createSelector([selectLedger], ledger => ledger.transliteratedReference)
